import React from 'react';
import { ControlledInputField } from 'components/controlled-input-field';
import { ControlledMultilineDropdownMenu } from 'features/my-zone/support-requests/components/support-requests-modals/components/inputs/controlled-multiline-dropdown';
import styles from './requests-chain.module.scss';
import {
    SupportRequestFormProps,
    SupportRequestModalForm,
} from 'features/my-zone/support-requests/components/support-requests-modals/components/support-request-modal-form';
import { SupportEmailInput } from 'features/my-zone/support-requests/components/support-requests-modals/components/inputs/controlled-support-email-input/support-email-input';
import { FormControl } from 'features/my-zone/support-requests/components/support-requests-modals/types';

const URL_REGEX = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?$/;

const analysisTypeItems = [
    {
        label: 'Chain Analysis',
        description:
            'Aggregated chain performance using readily available data.\nFastest delivery.',
        value: 'Chain Analysis',
    },
    {
        label: 'Detailed Store-Level Analysis',
        description:
            'Store-level property reports across the chain.\nLonger delivery time due to individual property review.',
        value: 'Detailed Store-Level Analysis',
    },
];

export interface RequestChainFormValues {
    type: 'chain';
    poiName: string;
    website: string;
    addTo: string[];
    analysisType: string;
}

export const requestChainFormConfig = {
    testId: 'request-chain',
    title: 'Request a Chain',
    requestType: 'chain',
    subTitle: 'Request the addition of a chain or improve coverage for existing chain',
    defaultValues: { type: 'chain' },
    convertToRequestPayload: (values) => values,
} as SupportRequestFormProps<RequestChainFormValues>;

export const RequestChain = ({ form }: { form?: FormControl<RequestChainFormValues> }) => {
    return (
        <SupportRequestModalForm<RequestChainFormValues> {...requestChainFormConfig} form={form}>
            <SupportEmailInput />
            <div className={styles.formContainer}>
                <div>
                    <ControlledInputField
                        name="poiName"
                        label="Chain Name"
                        placeholder="Name"
                        testId="chain-name-input"
                        asterix
                        required
                        maxLength={100}
                    />
                </div>
                <div>
                    <ControlledInputField
                        name="website"
                        label="Link to chain website (Store locator page if available)"
                        placeholder="e.g. www.acmecorp.com/store-finder"
                        testId="chain-website-input"
                        rules={{ pattern: { value: URL_REGEX, message: 'Invalid URL' } }}
                    />
                </div>
                <ControlledMultilineDropdownMenu
                    name="analysisType"
                    label="Analysis Type"
                    testId="type-input"
                    items={analysisTypeItems}
                    required
                    menuWidth={388}
                    asterix
                    closeOnSelection
                    placeholder="Select option"
                />
            </div>
        </SupportRequestModalForm>
    );
};
